import type { DashboardPreferences, WidgetId, WidgetSize } from "@/types";

const order: Array<{ id: WidgetId; size: WidgetSize }> = [
  { id: "revenue", size: "sm" },
  { id: "leads", size: "sm" },
  { id: "meetings", size: "sm" },
  { id: "proposals", size: "sm" },
  { id: "wonDeals", size: "sm" },
  { id: "outstandingInvoices", size: "sm" },
  { id: "salesPipeline", size: "lg" },
  { id: "pipelineValue", size: "md" },
  { id: "revenueTrend", size: "lg" },
  { id: "recentActivities", size: "md" },
  { id: "upcomingMeetings", size: "md" },
  { id: "leadSources", size: "md" },
  { id: "emailOutreach", size: "lg" },
  { id: "invoiceOverview", size: "md" },
  { id: "cmsPreview", size: "lg" },
  { id: "liveWebsitePreview", size: "md" },
];

export const defaultDashboardPreferences: DashboardPreferences = {
  compactMode: false,
  widgets: order.map((item, index) => ({
    id: item.id,
    size: item.size,
    order: index,
    visible: true,
  })),
};

export const widgetMeta: Record<
  WidgetId,
  { title: string; subtitle: string }
> = {
  revenue: { title: "Revenue", subtitle: "Collected this period" },
  leads: { title: "Leads", subtitle: "New qualified leads" },
  meetings: { title: "Meetings", subtitle: "Booked & completed" },
  proposals: { title: "Proposals", subtitle: "Sent to prospects" },
  wonDeals: { title: "Won deals", subtitle: "Closed-won value" },
  outstandingInvoices: {
    title: "Outstanding invoices",
    subtitle: "Awaiting payment",
  },
  salesPipeline: { title: "Sales pipeline", subtitle: "Deals by stage" },
  pipelineValue: { title: "Pipeline value", subtitle: "Weighted + total" },
  revenueTrend: { title: "Revenue trend", subtitle: "Last 6 months" },
  recentActivities: { title: "Recent activities", subtitle: "Team timeline" },
  upcomingMeetings: { title: "Upcoming meetings", subtitle: "Next 7 days" },
  leadSources: { title: "Lead sources", subtitle: "Attribution mix" },
  emailOutreach: {
    title: "Email outreach performance",
    subtitle: "Sent · opened · replied",
  },
  invoiceOverview: { title: "Invoice overview", subtitle: "Cash flow snapshot" },
  cmsPreview: { title: "Website CMS", subtitle: "Recent content activity" },
  liveWebsitePreview: {
    title: "Live website preview",
    subtitle: "cyberwebopera.com",
  },
};
